import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import ErrorModal from "../../components/ErrorModal";
import handleApiError from "../../../utils/handleApiError";
import SuccessModal from "../../components/SuccessModal";
import axios from "../../../axios";
import BannerForm from "./BannerForm";

export default function BannerCreatePage() {
    const [form, setForm] = useState({
        title: "",
        image: null,
    });

    const navigate = useNavigate();
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        setLoading(true);

        e.preventDefault();
        setError("");

        const formData = new FormData();
        formData.append("title", form.title || "");
        formData.append("image", form.image);

        try {
            await axios.post("/admin/banners", formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            setSuccess("Data berhasil ditambahkan!");
        } catch (err) {
            setError(handleApiError(err));
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Link to="/admin/banners" className=" mt-3">Kembali</Link>
            <ErrorModal error={error} onClose={() => setError("")} />
            <SuccessModal
                message={success}
                onClose={() => {
                    setSuccess("");
                    navigate("/admin/banners");
                }}
            />
            <div className="card mt-4">
                <div className="card-header border-bottom">
                    <h4 className="mb-0">Tambah Banner</h4>
                </div>
                <div className="card-body">
                    {error && <div className="alert alert-danger">{error}</div>}
                    <BannerForm form={form} setForm={setForm} onSubmit={handleSubmit} />

                </div>
            </div>
        </>
    );
}
